import { Grid } from "@material-ui/core";
import { CSSProperties, ReactElement, useState } from "react";
import RxButton from "../RxButton";
import RxDialog from "../RxDialog";
import RxLink from "../RxLink";
import RxProductPriceDetail from "../RxProductPriceDetail";
import RxTypography from "../RxTypography";
import styles from "./RxProductContent.module.css";

interface RxProductPriceDetailObject {
	price: number;
	additionPrice: number;
	minNumberOfProduct: number;
	maxNumberOfProduct: number;
	discount?: number;
}

interface RxProductContentProps {
	image?: ReactElement;
	title?: string;
	description?: string;
	priceInfo?: string;
	discountInfo?: string;
	actionComponent?: ReactElement;
	style?: CSSProperties;
	className?: string;
	priceDetail?: RxProductPriceDetailObject;
	discountDetail?: RxProductPriceDetailObject;
	kdvIncluded?: boolean;
}

const RxProductContent = (props: RxProductContentProps) => {
	const [showPriceDetail, setShowPriceDetail] = useState(false);

	return (
		<>
			<Grid
				container
				spacing={0}
				direction="column"
				justifyContent="space-between"
				alignItems="center"
				alignContent="center"
				className={styles.productContent}
			>
				{props.image && <Grid item>{props.image}</Grid>}
				{props.title && (
					<Grid item>
						<RxTypography
							variant="body1"
							align="center"
							label={props.title}
							className={styles.boldText}
						/>
					</Grid>
				)}
				{props.description && (
					<Grid item className={styles.contentSize}>
						<RxTypography
							variant="body2"
							align="center"
							label={props.description}
						/>
					</Grid>
				)}
				{props.priceDetail ? (
					<>
						<RxLink
							color={"error"}
							label="Fiyat listesi için tıklayınız."
							onClick={() => {
								setShowPriceDetail(true);
							}}
						/>
					</>
				) : (
					<>
						{props.priceInfo && (
							<Grid item>
								<RxTypography
									variant="body2"
									align="center"
									label={props.priceInfo}
									className={
										props.discountInfo
											? styles.priceInfoWithDiscount
											: styles.priceInfo
									}
								/>
							</Grid>
						)}
						{props.discountInfo && (
							<Grid item>
								<RxTypography
									variant="body2"
									align="center"
									label={props.discountInfo}
									className={styles.discountInfo}
								/>
							</Grid>
						)}
					</>
				)}
				{props.actionComponent && <Grid item>{props.actionComponent}</Grid>}
			</Grid>
			{showPriceDetail && (
				<RxDialog
					title={props.title + " Fiyat Bilgileri"}
					maxWidth="sm"
					fullWidth
					handleClose={() => {
						setShowPriceDetail(false);
					}}
					actions={
						<>
							<RxButton
								fullWidth
								label="Tamam"
								color="primary"
								variant="contained"
								onClick={() => {
									setShowPriceDetail(false);
								}}
							/>
						</>
					}
				>
					<RxProductPriceDetail
						price={props.priceDetail?.price ?? 0}
						priceWithDiscount={props.discountDetail?.price ?? -1}
						additionPrice={props.priceDetail?.additionPrice ?? 0}
						minNumberOfProduct={
							props.priceDetail?.minNumberOfProduct ?? 0
						}
						maxNumberOfProduct={
							props.priceDetail?.maxNumberOfProduct ?? 0
						}
						kdvIncluded={props.kdvIncluded ?? true}
						discount={props.discountDetail?.discount ?? -1}
					/>
				</RxDialog>
			)}
		</>
	);
};

export default RxProductContent;
